/**
 * Documents List
 *
 * Placeholder component for documents list.
 */

import { View } from "react-native";
import { Text } from "@louise/ui/Text/Text";

export function DocumentsList() {
  return (
    <View className="mb-8 rounded-2xl border border-white/10 bg-slate-900/50 p-4">
      <Text className="text-sm text-slate-400">Documents coming soon</Text>
    </View>
  );
}
